import { Box, Text, Wrap, WrapItem, Stack, Avatar, Skeleton, Icon, chakra } from '@chakra-ui/react'
import _ from 'lodash'
import moment from 'moment'
import React, { useCallback, useState } from 'react'
import { SelectOption } from 'types/transaction.type'
import { truncateWithEllipsis } from 'utils/string-formatters'
import { useAllResidents, useSelectedResidentContact } from '../contact-center.hooks'
import { FilterType } from './CallLog'
import { useLogs } from './hooks'

type LogRecordProps = {
  filter: SelectOption
}
type LogRecordItemProps = {
  contact: any
  filter: SelectOption
}

export const LogRecords: React.FC<LogRecordProps> = ({ filter }) => {
  
  const { data: callLogs, isLoading: isLoadingLogs } = useLogs()

  const { data: residents, isLoading: isLoadingResidents } = useAllResidents()

  const logs = _.orderBy(callLogs?.filter(c => c.callType === filter.value || filter.value === FilterType.All), ["id"], ["desc"] )
  
  if (isLoadingLogs || isLoadingResidents) {
    return (
      <Stack px="15px" top="20px" pos="relative">
        <Skeleton height="20px" />
        <Skeleton height="20px" />
        <Skeleton height="20px" />
      </Stack>
    )
  }

  //console.log('🚀 ~ file: LogRecords.tsx:11 ~ residents:', residents)

  //console.log('🚀 ~ file: LogList.tsx:11 ~ data:', callLogs)

  return (
    <Box overflowY="auto" maxH="580.5px" minH="580.5px" overflowX="hidden" pos="relative" w="100%">
      <Stack spacing="25px" mt="10px">
        {logs.map((contact, idx) => {
          
          let contactRet = _.clone(
            residents?.find(
              (r: any) =>
                contact.phoneNo.replace(/\D/g, '').replace(/^1/, '') ===
                r.phoneNumber?.toString().replace(/\D/g, '').replace(/^1/, ''),
            ) as any,
          )

          if (!contactRet) return null

          contactRet.callTime = contact.callTime
          contactRet.callType = contact.callType
          contactRet.logId = contact.id

          return <LogRecordItem contact={contactRet} key={contact.id} filter={filter} />
        })}
      </Stack>
    </Box>
  )
}

export const LogRecordItem: React.FC<LogRecordItemProps> = ({ contact, filter }) => {
  const [, setIsHovered] = useState(false)
  const mouseEnter = useCallback(() => setIsHovered(true), [])
  const mouseLeave = useCallback(() => setIsHovered(false), [])
  const { setSelected } = useSelectedResidentContact()

  return (
    <Box
      py="16px"
      px="20px"
      //bg={selected?.id === contact.id ? '#F2F7FE' : ''}
      _hover={{
        bg: '#F2F7FE',
      }}
      width="100%"
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      pos="relative"
      marginTop="0px !important"
      onClick={() => setSelected(contact)}
    >
      <Wrap cursor="pointer" onClick={() => {}} key={contact.id}>
        <WrapItem>
          <Avatar name={`${contact.firstName} ${contact.lastName}`} size="md" />
          <chakra.span pos="relative" top="15px" left="5px">
            {contact.callType === FilterType.INCOMING && <Icon as={IncomingIcon} />}
            {contact.callType === FilterType.OUTGOING && <Icon as={OutgoingIcon} />}
          </chakra.span>
        </WrapItem>
        <WrapItem>
          <Stack spacing="3px">
            <Text fontSize="12px" color="gray.600" fontWeight="500" isTruncated={true}>
              {truncateWithEllipsis(`${contact.firstName} ${contact.lastName}`, 30)}
            </Text>
            <Text fontSize="12px" fontWeight="400" color="gray.700">
              {contact.phoneNumber}
            </Text>
            <Text fontSize="12px" fontWeight="400" color="gray.700">
              {moment.utc(contact.callTime).local().format('MMM D, h:mm A')}
            </Text>
          </Stack>
        </WrapItem>
      </Wrap>
    </Box>
  )
}

const IncomingIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M7 3.8355L2.91667 7.91883V5.25008H1.75V9.91675H6.41667V8.75008H3.73333L7 5.48341L11.4333 9.91675L12.25 9.0855L7 3.8355Z"
        fill="#48BB78"
      />
    </svg>
  )
}

const OutgoingIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
      <path
        d="M0 0.868213L5.54179 6.41L9.85207 2.09972V4.92603H11.0836V0H6.15754V1.23151H8.98385L5.54179 4.67357L0.868213 0L0 0.868213Z"
        fill="#4E87F8"
      />
    </svg>
  )
}
